
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class WorkflowStatusGrid extends SiteEntityGrid<WorkflowStatusRow, any> {
        protected getColumnsKey() { return 'Workflow.WorkflowStatus'; }
        protected getDialogType() { return WorkflowStatusDialog; }
        protected getIdProperty() { return WorkflowStatusRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowStatusRow.localTextPrefix; }
        protected getService() { return WorkflowStatusService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}